<div class=" h-full rounded-lg border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-700 dark:bg-gray-900">
  <div class="mb-4 flex items-center justify-between">
    <h3 class="flex items-center text-lg font-semibold text-gray-900 dark:text-white">
      <i class="pi pi-exclamation-triangle mr-2 text-red-500"></i>
      {{ 'dashboard.issues.title' | translate }}
    </h3>
  </div>

  @if (isLoading()) {
    <div class="space-y-3">
      @for (i of [1, 2]; track i) {
        <div class="h-16 animate-pulse rounded-lg bg-gray-200 dark:bg-gray-700"></div>
      }
    </div>
  } @else if (error()) {
    <div class="py-4 text-center">
      <p class="text-red-600 dark:text-red-400">{{ error() }}</p>
      <button
        class="mt-2 text-sm text-blue-600 hover:text-blue-800"
        (click)="loadIssueOverview()"
      >
        {{ 'common.retry' | translate }}
      </button>
    </div>
  } @else {
    <div class="space-y-3">
      <!-- Open Issues -->
      <div class="flex items-center justify-between rounded-lg border border-red-200 bg-red-50 p-3 dark:border-red-800 dark:bg-red-900/20">
        <div class="flex items-center">
          <div class="mr-3 h-3 w-3 rounded-full bg-red-500"></div>
          <span class="text-sm font-medium text-gray-900 dark:text-white">
            {{ 'dashboard.issues.open' | translate }}
          </span>
        </div>
        <div class="flex items-center">
          <span class="mr-2 text-lg font-bold text-red-600 dark:text-red-400">{{ issueData()?.open || 0 }}</span>
          <p-badge
            [value]="issueData()?.openPercentage || '0%'"
            severity="danger"
            size="small"
          >
          </p-badge>
        </div>
      </div>

      <!-- In Progress -->
      <div class="flex items-center justify-between rounded-lg border border-amber-200 bg-amber-50 p-3 dark:border-amber-800 dark:bg-amber-900/20">
        <div class="flex items-center">
          <div class="mr-3 h-3 w-3 rounded-full bg-amber-500"></div>
          <span class="text-sm font-medium text-gray-900 dark:text-white">
            {{ 'dashboard.issues.inProgress' | translate }}
          </span>
        </div>
        <div class="flex items-center">
          <span class="mr-2 text-lg font-bold text-amber-600 dark:text-amber-400">{{ issueData()?.inProgress || 0 }}</span>
          <p-badge
            [value]="issueData()?.inProgressPercentage || '0%'"
            severity="warn"
            size="small"
          >
          </p-badge>
        </div>
      </div>
    </div>

    <!-- Manage Issues Button -->
    <div class="mt-4 border-t border-gray-200 pt-4 dark:border-gray-700">
      <p-button
        [label]="'dashboard.issues.manage' | translate"
        icon="pi pi-cog"
        class="w-full"
        severity="secondary"
        size="small"
        (click)="navigateToIssues()"
      >
      </p-button>
    </div>
  }
</div>
